import { render, staticRenderFns } from "./SmsTemplateModal.vue?vue&type=template&id=d20d4058&"
import script from "./SmsTemplateModal.vue?vue&type=script&lang=js&"
export * from "./SmsTemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports